import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Griddle, {
  ColumnDefinition,
  RowDefinition,
  plugins,
} from "griddle-react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import CardBody from "components/Card/CardBody.jsx";
import { DateColumn } from "components/Table/TableRows.jsx";

const accounting = require("accounting");

const NewLayout = ({ Table, Pagination }) => (
  <div>
    <Table />
    <br />
    <Pagination />
  </div>
);

class AlertTable extends React.Component {
  render() {
    let {
      classes,
      tableData,
      tableHeaderColor,
      tableType,
      locationName,
    } = this.props;

    const styleConfig = {
      icons: {
        TableHeadingCell: {
          sortDescendingIcon: <div />,
          sortAscendingIcon: <div />,
        },
      },
      classNames: {
        Table: `${classes.table}`,
        TableHeadingCell: `${classes.tableHeadCell}`,
        TableHeading: `${classes[tableHeaderColor + "TableHeader"]}`,
        Cell: `${classes.tableCell}`,
        Row: `${classes.tableRow}`,
      },
    };

    const moneyCol = ({ value, griddleKey, money }) => {
      return <div>{accounting.formatMoney(value)}</div>;
    };

    const StatusColumn = ({ value, griddleKey, data }) => {
      return <div style={{ color: "#ff0000" }}>{value}</div>;
    };

    const AdminColumn = ({ value, griddleKey, data }) => {
      const access = value === 0 ? "User" : "Admin";
      return <div>{access}</div>;
    };

    // For Members page, edit and delete button actions
    const ActionColumn = ({ value, griddleKey, data }) => {
      const mem = tableData[griddleKey];
      const memId = mem.MemberId;

      return (
        <div>
          <Tooltip
            id="tooltip-top"
            title="Edit User"
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.props.editMember(memId);
              }}
              aria-label="Edit"
              className={classes.tableActionButton}
            >
              <Edit
                className={classes.tableActionButtonIcon + " " + classes.edit}
              />
            </IconButton>
          </Tooltip>
          <Tooltip
            id="tooltip-top-start"
            title="Remove User"
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.props.deleteMember(memId);
              }}
              aria-label="Close"
              className={classes.tableActionButton}
            >
              <Close
                className={classes.tableActionButtonIcon + " " + classes.close}
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };

    // For Alert page, called on load and on a dismiss
    const AlertActionColumn = ({ value, griddleKey, data }) => {
      const alert = tableData[griddleKey];

      return (
        <div>
          <Tooltip
            id="tooltip-top-start"
            title="Dismiss Alert"
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <IconButton
              onClick={() => {
                this.props.dismissAlert(tableType, locationName, alert);
                tableData.splice(griddleKey, 1);
              }}
              aria-label="Close"
              className={classes.tableActionButton}
            >
              <Close
                className={classes.tableActionButtonIcon + " " + classes.close}
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };

    const rowDataSelector = (state, { griddleKey }) => {
      return state
        .get("data")
        .find((r) => r.get("griddleKey") === griddleKey)
        .toJSON();
    };

    //
    const enhancedWithRowData = connect((state, props) => {
      return {
        rowData: rowDataSelector(state, props),
      };
    });

    let tableKey = Math.floor(Math.random() * 100);

    /** Define tables for each tab **/
    let tableRowDef = <RowDefinition />;

    if (tableType === "Errors") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="RECYCLER_ID" title="Recycler ID" />
          <ColumnDefinition id="RECYCLER_NAME" title="Recycler Name" />
          <ColumnDefinition id="EC_CODE" title="Error Code" />
          <ColumnDefinition id="EC_DESC" title="Error Description" />
          <ColumnDefinition
            id="LOG_DATE_TIME"
            title="Date"
            customComponent={DateColumn}
          />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(AlertActionColumn)} // calls AlertActionColumn >> then calls enhancedWithRowData
          />
        </RowDefinition>
      );
    }

    if (tableType === "OpenTill") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="User Name" title="User Name" />
          <ColumnDefinition id="Register Name" title="Register Name" />
          <ColumnDefinition id="Last Transaction" title="Latest Transaction" />
          <ColumnDefinition id="Transaction ID" title="Transaction ID" />
          <ColumnDefinition
            id="Transaction Time"
            title="Transaction Time"
            customComponent={DateColumn}
          />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(AlertActionColumn)}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Replication") {
      const tmpData = [];

      tableData.map((rep) => {
        Object.keys(rep).map((key) => {
          const latestLogin = new Date(rep[key].latestLogin);
          const latestTransaction = new Date(rep[key].latestTransaction);

          tmpData.push({
            location: key,
            latestLogin: latestLogin.toLocaleString("en-US"),
            latestTransaction: latestTransaction.toLocaleString("en-US"),
            status: rep[key].status,
          });
        });
      });

      tableData = tmpData;

      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="location" title="Location" />
          <ColumnDefinition id="latestLogin" title="Latest Login" />
          <ColumnDefinition id="latestTransaction" title="Latest Transaction" />
          <ColumnDefinition
            id="status"
            title="Status"
            customComponent={StatusColumn}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Members") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition
            id="Access"
            title="Type"
            customComponent={AdminColumn}
          />
          <ColumnDefinition id="Email" title="Email" />
          <ColumnDefinition id="FirstName" title="First Name" />
          <ColumnDefinition id="LastName" title="Last Name" />
          <ColumnDefinition id="LocationName" title="Location" />
          <ColumnDefinition
            width={"10%"}
            id=""
            title=""
            customComponent={enhancedWithRowData(ActionColumn)}
          />
        </RowDefinition>
      );
    }

    if (tableType === "Threshold") {
      tableRowDef = (
        <RowDefinition>
          <ColumnDefinition id="RECYCLER_ID" title="Recycler" />
          <ColumnDefinition id="UNIT_ID" title="Unit ID" />
          <ColumnDefinition
            id="NOTE_VALUE"
            title="Value"
            customComponent={moneyCol}
          />
          <ColumnDefinition id="QUANTITIES" title="Count" />
          <ColumnDefinition
            id="AMOUNT"
            title="Total"
            customComponent={moneyCol}
          />
        </RowDefinition>
      );
    }

    return (
      <div>
        <CardBody>
          <div className={classes.tableContainer}>
            <Griddle
              data={tableData}
              plugins={[plugins.LocalPlugin]}
              key={tableKey}
              styleConfig={styleConfig}
              components={{
                Layout: NewLayout,
              }}
            >
              {tableRowDef}
            </Griddle>
          </div>
        </CardBody>
      </div>
    );
  }
}

AlertTable.defaultProps = {
  tableHeaderColor: "gray",
};

AlertTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "scmain",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.object),
};

export default withStyles(tableStyle)(AlertTable);



// WEBPACK FOOTER //
// ./src/components/Table/AlertTable.jsx